export default __webpack_public_path__ + "static/media/jj_map.dc3cbb84.png";